import React, { useState, useEffect } from "react";

//css
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row, Card, Button } from "react-bootstrap";

//ant design
import "antd/dist/antd.css";
import { CalendarFilled, ClockCircleFilled } from "@ant-design/icons";

//date picker
import PickyDateTime from "react-picky-date-time";
import Timekeeper from "react-timekeeper";

//firebase
import { db } from "../firebase/firebase";

//toast
import { alert } from "../util/toast";

//routing
import { useHistory } from "react-router-dom";

//navbar
import Navbar from "./NavBar";

//dayjs
import dayjs from "dayjs";

//jquery
import $ from "jquery";

const Schedule = () => {
  const history = useHistory();
  var dateObj = new Date();
  let now = dayjs();

  // $(document).ready(function () {
  //   $(window).scrollTop(0);
  // });

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [resumeLink, setResumeLink] = useState("");
  const [company, setCompany] = useState("");
  const [interViewType, setInterViewType] = useState("");
  const [time, setTime] = useState([]);
  const [date, setDate] = useState({
    year: dateObj.getUTCMonth(),
    month: dateObj.getUTCDate(),
    date: dateObj.getUTCFullYear(),
  });

  const [errors, setError] = useState({
    name: "",
    email: "",
    resumeLink: "",
    company: "",
    interViewType: "",
    date: "",
    time: "",
  });

  useEffect(() => {
    const scheduleTitle = localStorage.getItem("ScheduleTitle");
    const id = localStorage.getItem("id");
    const detail = JSON.parse(localStorage.getItem("Detail"));
    scheduleTitle !== undefined && setInterViewType(scheduleTitle)
    setName(detail.name);
    setEmail(detail.email);
    setUserId(id);
  }, []);

  const onYearPicked = (res) => {
    let { year } = res;
    setDate({ year: year });
  };

  const onMonthPicked = (res) => {
    let { month, year } = res;
    setDate({ year: year, month: month });
  };

  const onDatePicked = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const onResetDate = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const onResetDefaultDate = (res) => {
    let { date, month, year } = res;
    setDate({ year: year, month: month, date: date });
  };

  const handleSelectTime = (id) => {
    // debugger;
    $(`#${id}`).toggleClass("timePickerActive");
    const selectedTime = $(`#${id}`).hasClass("timePickerActive");
    if (selectedTime) {
      time.push(id);
    } else {
      let index = time.indexOf(id);
      if (index != -1) {
        time.splice(index, 1); // remove 1 element from index
      }
    }
  };

  // console.log(new Date(date.year + "-" + date.month + "-" + date.date))

  const handleShedule = async () => {
    debugger;
    if (
      !name ||
      !email ||
      !resumeLink ||
      !company ||
      !interViewType ||
      time.length == 0
    ) {
      const errors = {};

      if (!name) {
        errors.name = "Name is Required!";
      }
      if (!email) {
        errors.email = "Email is Required!";
      }
      if (!resumeLink) {
        errors.resumeLink = "Resume Link is Required!";
      }
      if (!company) {
        errors.company = "Company is Required!";
      }
      if (!interViewType) {
        errors.interViewType = "Select atleast one!";
      }
      if (time.length == 0) {
        errors.time = "Please select one time slot!";
      }

      return setError({ ...errors });
    }

    if (
      now.diff(
        new Date(date.year + "-" + date.month + "-" + date.date),
        "days"
      ) > 0
    ) {
      return setError({ ...errors, date: "You can't select previos date!" });
    }

    const _d = await db
      .collection("scheduleInterview")
      .where("userId", "==", parseInt(userId))
      .get();

    let existCount = 0;
    for (let i = 0; i < _d.size; i++) {
      const doc = _d.docs[i];
      if (
        doc.data().date.toDate().toString() !=
        new Date(date.year + "-" + date.month + "-" + date.date).toString()
      ) {
        existCount++;
      }
    }

    if (existCount === _d.size) {
      // create record here
      const data = { name: name, email: email };
      const query = await db
        .collection("users")
        .where("_id", "==", parseInt(userId))
        .get();

      const userFirebaseId = query.docs[0].id;

      await db.doc(`/users/${userFirebaseId}`).update(data);

      await db.collection("scheduleInterview").add({
        userId: parseInt(userId),
        date: new Date(date.year + "-" + date.month + "-" + date.date),
        time: time,
        resumeLink: resumeLink,
        company: company,
        interViewType: interViewType,
      });
      localStorage.removeItem("ScheduleTitle")
      localStorage.setItem(
        "Detail",
        JSON.stringify({
          name: name,
          email: email,
        })
      );

      localStorage.setItem(
        "InterViewData",
        JSON.stringify({
          date: new Date(date.year + "-" + date.month + "-" + date.date),
          time: time,
          company: company,
          interViewType,
        })
      );

      alert("success", "Interview Schedule Successful!");

      return setTimeout(() => {
        history.push("/payment");
      }, [3000]);
    } else {
      return alert("error", "You can't schedule twice interview at same time!");
    }
  };

  return (
    <>
      <Navbar />
      <div className="bgColor">
        <Container fluid="sm">
          <Row className="py-5">
            <Col className="py-3 ">
              <Card
                className="mx-auto"
                style={{
                  borderRadius: 15,
                  borderColor: "#3F8AF7",
                }}
              >
                <Card.Title className="p-3 font-weight-bold ">
                  <Col
                    md={12}
                    className="py-3 text-center"
                    style={{ fontSize: 28, color: "#2E8CFF" }}
                  >
                    Schedule Interview
                  </Col>
                </Card.Title>
                <Card.Body className="m-md-5 m-0 border-top ">
                  <Row className="m-auto py-4 ">
                    <Col sm={12} md={6} className="overflow-auto">
                      <label className="font-weight-bold ml-md-5 pl-md-2 ml-0 pl-0">
                        When
                      </label>

                      <div className="text-center pb-5">
                        <div
                          className="input-group mx-auto"
                          style={{ width: "73%" }}
                        >
                          <input
                            className="form-control border-right-0"
                            value={`${date.date}/${date.month}/${date.year}`}
                            onClick={() =>
                              setDate({
                                date: dateObj.getUTCFullYear(),
                                month: dateObj.getUTCDate(),
                                year: dateObj.getUTCMonth(),
                              })
                            }
                          />
                          <span className="input-group-append bg-white border-left-0">
                            <span className="input-group-text bg-transparent">
                              <CalendarFilled />
                            </span>
                          </span>
                        </div>
                        <PickyDateTime
                          size="m"
                          mode={0}
                          show={true}
                          locale="en-us"
                          defaultDate={`${date.date}/${date.month}/${date.year}`}
                          onYearPicked={(res) => onYearPicked(res)}
                          onMonthPicked={(res) => onMonthPicked(res)}
                          onDatePicked={(res) => onDatePicked(res)}
                          onResetDate={(res) => onResetDate(res)}
                          onResetDefaultDate={(res) => onResetDefaultDate(res)}
                        />
                        {errors.date && (
                          <div class="ml-5 text-left">
                            <p className="text-danger">{errors.date}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={12} md={6} className="overflow-auto mt-1">
                      <label className="font-weight-bold ml-0 pl-0">
                        Select Time
                      </label>
                      <div className="timePicker">
                        <Row className="horizontalWrap">
                          <Col
                            id="00"
                            onClick={() => handleSelectTime("00")}
                            className="borerRight"
                          >
                            00:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="01"
                            onClick={() => handleSelectTime("01")}
                          >
                            01:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="02"
                            onClick={() => handleSelectTime("02")}
                          >
                            02:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="03"
                            onClick={() => handleSelectTime("03")}
                          >
                            03:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="04"
                            onClick={() => handleSelectTime("04")}
                          >
                            04:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="05"
                            onClick={() => handleSelectTime("05")}
                          >
                            05:00
                          </Col>
                        </Row>
                      </div>
                      <div className="timePicker mt-4">
                        <Row className="horizontalWrap">
                          <Col
                            className="borerRight"
                            id="06"
                            onClick={() => handleSelectTime("06")}
                          >
                            06:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="07"
                            onClick={() => handleSelectTime("07")}
                          >
                            07:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="08"
                            onClick={() => handleSelectTime("08")}
                          >
                            08:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="09"
                            onClick={() => handleSelectTime("09")}
                          >
                            09:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="10"
                            onClick={() => handleSelectTime("10")}
                          >
                            10:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="11"
                            onClick={() => handleSelectTime("11")}
                          >
                            11:00
                          </Col>
                        </Row>
                      </div>

                      <div className="timePicker mt-4">
                        <Row className="horizontalWrap">
                          <Col
                            className="borerRight"
                            id="12"
                            onClick={() => handleSelectTime("12")}
                          >
                            12:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="13"
                            onClick={() => handleSelectTime("13")}
                          >
                            13:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="14"
                            onClick={() => handleSelectTime("14")}
                          >
                            14:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="15"
                            onClick={() => handleSelectTime("15")}
                          >
                            15:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="16"
                            onClick={() => handleSelectTime("16")}
                          >
                            16:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="17"
                            onClick={() => handleSelectTime("17")}
                          >
                            17:00
                          </Col>
                        </Row>
                      </div>

                      <div className="timePicker mt-4">
                        <Row className="horizontalWrap">
                          <Col
                            className="borerRight"
                            id="18"
                            onClick={() => handleSelectTime("18")}
                          >
                            18:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="19"
                            onClick={() => handleSelectTime("19")}
                          >
                            19:00
                          </Col>

                          <Col
                            className="borerRight"
                            id="20"
                            onClick={() => handleSelectTime("20")}
                          >
                            20:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="21"
                            onClick={() => handleSelectTime("21")}
                          >
                            21:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="22"
                            onClick={() => handleSelectTime("22")}
                          >
                            22:00
                          </Col>
                          <Col
                            className="borerRight"
                            id="23"
                            onClick={() => handleSelectTime("23")}
                          >
                            23:00
                          </Col>
                        </Row>
                      </div>
                      {errors.time && (
                        <div class="pl-1 text-left">
                          <p className="text-danger">{errors.time}</p>
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row className="py-5 border-top">
                    <Col sm={12} md={6}>
                      <div class="form-group mx-auto" style={{ width: "75%" }}>
                        <label for="name" className="font-weight-bold">
                          Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          placeholder="name"
                          value={name}
                          disabled
                          onChange={(e) => {
                            setName(e.target.value);

                            if (!e.target.value) {
                              return setError({
                                ...errors,
                                name: "Name is Required!",
                              });
                            } else {
                              return setError({
                                ...errors,
                                name: "",
                              });
                            }
                          }}
                        />
                        {errors.name && (
                          <div class="pl-1 text-left">
                            <p className="text-danger">{errors.name}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={12} md={6}>
                      <div class="form-group mx-auto" style={{ width: "75%" }}>
                        <label for="email " className="font-weight-bold">
                          Email
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          placeholder="name@example.com"
                          value={email}
                          disabled
                          onChange={(e) => {
                            setEmail(e.target.value);

                            if (!e.target.value) {
                              return setError({
                                ...errors,
                                email: "Email is Required!",
                              });
                            } else {
                              return setError({
                                ...errors,
                                email: "",
                              });
                            }
                          }}
                        />
                        {errors.email && (
                          <div class="pl-1 text-left">
                            <p className="text-danger">{errors.email}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12} md={6}>
                      <div class="form-group mx-auto" style={{ width: "75%" }}>
                        <label for="link" className="font-weight-bold">
                          Resume Link
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="link"
                          placeholder="link"
                          value={resumeLink}
                          onChange={(e) => {
                            setResumeLink(e.target.value);

                            if (!e.target.value) {
                              return setError({
                                ...errors,
                                resumeLink: "Resume Link is Required!",
                              });
                            } else {
                              return setError({
                                ...errors,
                                resumeLink: "",
                              });
                            }
                          }}
                        />
                        {errors.resumeLink && (
                          <div class="pl-1 text-left">
                            <p className="text-danger">{errors.resumeLink}</p>
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col sm={12} md={6}>
                      <div class="form-group mx-auto" style={{ width: "75%" }}>
                        <label for="interviewType" className="font-weight-bold">
                          Interview Type
                        </label>
                        <select
                          class="form-control"
                          id="interviewType"
                          value={interViewType}
                          onChange={(e) => {
                            setInterViewType(e.target.value);

                            if (!e.target.value) {
                              return setError({
                                ...errors,
                                interViewType: "Select Atleast one!",
                              });
                            } else if (e.target.value == "select") {
                              return setError({
                                ...errors,
                                select: "Select Atleast one!",
                              });
                            } else {
                              return setError({
                                ...errors,
                                interViewType: "",
                              });
                            }
                          }}
                        >
                          <option value="select">Select Interview Type</option>
                          <option value="Resume Deep Dive And Behavioral">
                            Resume Deep Dive And Behavioral
                          </option>
                          <option value="Problem Solving And Behavioral">
                            Problem Solving And Behavioral
                          </option>
                          <option value="System Design [LLD/HLD] And Behavioral">
                            System Design [LLD/HLD] And Behavioral
                          </option>
                          <option value="Technical Mock Interview [coding, design]">
                            Technical Mock Interview [coding, design]
                          </option>
                          <option value="Premium Mock Interview [Technical, HM, HR]">
                            Premium Mock Interview [Technical, HM, HR]
                          </option>
                        </select>
                        {errors.interViewType && (
                          <div class="pl-1 text-left">
                            <p className="text-danger">
                              {errors.interViewType}
                            </p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="py-5">
                    <Col sm={12} md={6}>
                      <div class="form-group mx-auto" style={{ width: "75%" }}>
                        <label for="company" className="font-weight-bold">
                          Company
                        </label>

                        <select
                          class="form-control"
                          id="company"
                          value={company}
                          onChange={(e) => {
                            setCompany(e.target.value);

                            if (!e.target.value) {
                              return setError({
                                ...errors,
                                company: "Comapny Name is Required!",
                              });
                            } else {
                              return setError({
                                ...errors,
                                company: "",
                              });
                            }
                          }}
                        >
                          <option value="select">Select Company</option>
                          <option value="Software Company">
                            Software Company
                          </option>
                          <option value="Private Company">
                            Private Company
                          </option>
                          <option value="Public Company">Public Company</option>
                          <option value="Associate Company">
                            Associate Company
                          </option>
                          <option value="One Person Companys">
                            One Person Companys
                          </option>
                        </select>
                        {errors.company && (
                          <div class="pl-1 text-left">
                            <p className="text-danger">{errors.company}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className="m-auto text-center pt-2">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="mt-3 shadow-lg btn"
                      style={{ height: 60, fontSize: 20, fontWeight: "bold" }}
                      onClick={handleShedule}
                    >
                      Schedule Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Schedule;
